/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AbstractService, ServiceCallType } from '@iotize/tap';

export class EthernetService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get Ethernet IP
   *
   * LWM2M path: /1024//85
   *
   * @tapVersion(">=2.7")
   * @return
   */
  getIp(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getIpCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//85
   *
   * @tapVersion(">=2.7")
   * @return call options
   */
  getIpCall(): ServiceCallType {
    const callOptions = { ...this.resources.getIp };

    return callOptions;
  }

  /**
   * Set ethernet IP address
   *
   * LWM2M path: /1024//85
   *
   * @tapVersion(">=2.7")
   * @param data input
   * @return
   */
  putIp(
    /*
     *
     */
    data: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putIpCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1024//85
   *
   * @tapVersion(">=2.7")
   * @param data input
   * @return call options
   */
  putIpCall(
    /*
     *
     */
    data: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putIp };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Get gateway IP address
   *
   * LWM2M path: /1024//86
   *
   * @tapVersion(">=2.7")
   * @return
   */
  getGatewayIp(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getGatewayIpCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//86
   *
   * @tapVersion(">=2.7")
   * @return call options
   */
  getGatewayIpCall(): ServiceCallType {
    const callOptions = { ...this.resources.getGatewayIp };

    return callOptions;
  }

  /**
   * Write gateway IP address
   *
   * LWM2M path: /1024//86
   *
   * @tapVersion(">=2.7")
   * @param data input
   * @return
   */
  putGatewayIp(
    /*
     *
     */
    data: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putGatewayIpCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1024//86
   *
   * @tapVersion(">=2.7")
   * @param data input
   * @return call options
   */
  putGatewayIpCall(
    /*
     *
     */
    data: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putGatewayIp };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Get ethernet gateway IP mask
   *
   * LWM2M path: /1024//87
   *
   * @tapVersion(">=2.7")
   * @return
   */
  getIpMask(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getIpMaskCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//87
   *
   * @tapVersion(">=2.7")
   * @return call options
   */
  getIpMaskCall(): ServiceCallType {
    const callOptions = { ...this.resources.getIpMask };

    return callOptions;
  }

  /**
   * Write ethernet gateway IP mask
   *
   * LWM2M path: /1024//87
   *
   * @tapVersion(">=2.7")
   * @param data input
   * @return
   */
  putIpMask(
    /*
     *
     */
    data: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putIpMaskCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1024//87
   *
   * @tapVersion(">=2.7")
   * @param data input
   * @return call options
   */
  putIpMaskCall(
    /*
     *
     */
    data: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putIpMask };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Get ethernet hostname
   *
   * LWM2M path: /1024//93
   *
   * @tapVersion(">=2.7")
   * @return
   */
  getHostname(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getHostnameCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//93
   *
   * @tapVersion(">=2.7")
   * @return call options
   */
  getHostnameCall(): ServiceCallType {
    const callOptions = { ...this.resources.getHostname };

    return callOptions;
  }

  /**
   * Get ethernet network dns ip
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=2.7")
   * @return
   */
  getDnsIp(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getDnsIpCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=2.7")
   * @return call options
   */
  getDnsIpCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDnsIp };

    return callOptions;
  }

  /**
   * Write ethernet network dns ip
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=2.7")
   * @param key input
   * @return
   */
  putDnsIp(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putDnsIpCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=2.7")
   * @param key input
   * @return call options
   */
  putDnsIpCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putDnsIp };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get Ethernet enable status
   *
   * LWM2M path: /1024//130
   *
   * @tapVersion(">=2.7")
   * @return
   */
  getEnabled(): Promise<TapResponse<boolean>> {
    return this.serviceCallRunner.execute(this.getEnabledCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//130
   *
   * @tapVersion(">=2.7")
   * @return call options
   */
  getEnabledCall(): ServiceCallType {
    const callOptions = { ...this.resources.getEnabled };

    return callOptions;
  }

  /**
   * Write Ethernet enable status
   *
   * LWM2M path: /1024//130
   *
   * @tapVersion(">=2.7")
   * @param isEnabled input
   * @return
   */
  putEnabled(
    /*
     *
     */
    isEnabled: boolean,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putEnabledCall(isEnabled));
  }

  /**
   *
   *
   * LWM2M path: /1024//130
   *
   * @tapVersion(">=2.7")
   * @param isEnabled input
   * @return call options
   */
  putEnabledCall(
    /*
     *
     */
    isEnabled: boolean,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putEnabled };

    callOptions.body = isEnabled;

    return callOptions;
  }
}
